<template>
  <div class="contact">
    <div class="contact-info">
      <h1>Contact Us</h1>
      <div>
        <p style="text-align: center;">
          Email:
          <a
            href="mailto:info@truelifecare.org"
            target="_blank"
            rel="noopener noreferrer"
          >info@truelifecare.org</a>
        </p>
        <p style="text-align: center;">Phone:&nbsp;(800) 749-0570</p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'contact'
}
</script>
<style lang="scss">
.contact {
  background-image: url(http://truelifecare2.wpengine.com/wp-content/uploads/2017/06/share_your_story.jpg?id=2129) !important;
  background-position: center !important;
  background-repeat: no-repeat !important;
  background-size: cover !important;
  min-height: 80vh;
  display: flex;
  align-items: center;
  justify-content: center;
  &-info {
    padding-top: 50px !important;
    padding-right: 25px !important;
    padding-bottom: 50px !important;
    padding-left: 25px !important;
    background-color: rgba(0, 0, 0, 0.5) !important;
    border-radius: 10px !important;
    width: 90%;
    max-width: 600px;
    text-align: center;
    a {
      color: #2ba048;
    }
  }
}
</style>
